const dateOnly = (value) => (value ? value.slice(0, 10) : '');
const timeOnly = (value) => (value ? value.slice(0, 5) : '');

const getStart = (reservation) =>
    new Date(`${dateOnly(reservation.odKiedy)}T${timeOnly(reservation.odGodzina) || '00:00'}:00`);

const getEndExclusive = (reservation) => {
    const date = dateOnly(reservation.doKiedy);
    const endTime = timeOnly(reservation.doGodzina);
    if (endTime) {
        return new Date(`${date}T${endTime}:00`);
    }

    const end = new Date(`${date}T00:00:00`);
    end.setDate(end.getDate() + 1);
    return end;
};

export const hasReservationOverlap = (first, second) => {
    if (!first.odKiedy || !first.doKiedy || !second.odKiedy || !second.doKiedy) return false;

    const firstHasTime = Boolean(first.odGodzina || first.doGodzina);
    const secondHasTime = Boolean(second.odGodzina || second.doGodzina);

    if (!firstHasTime && !secondHasTime) {
        const firstStart = new Date(first.odKiedy);
        const firstEnd = new Date(first.doKiedy);
        const secondStart = new Date(second.odKiedy);
        const secondEnd = new Date(second.doKiedy);
        return !(firstEnd < secondStart || firstStart > secondEnd);
    }

    const firstStart = getStart(first);
    const firstEnd = getEndExclusive(first);
    const secondStart = getStart(second);
    const secondEnd = getEndExclusive(second);
    return firstStart < secondEnd && secondStart < firstEnd;
};

export const hasValidReservationPeriod = (reservation) => {
    if (!reservation.odGodzina && !reservation.doGodzina) return true;
    if (!reservation.odKiedy || !reservation.doKiedy) return false;

    return getStart(reservation) < getEndExclusive(reservation);
};